module.exports = __webpack_public_path__ + "static/media/PARTIES_RESULTS_REACT_LEVEL_ONE_NEW.abe273ca.csv";